import { Injectable, signal, WritableSignal } from '@angular/core';
import { MapToolbarAction, MapToolbarPayload } from '../map-toolbar/map-toolbar-actions';

@Injectable({
  providedIn: 'root'
})
export class MapToolbarService {
  actionSignal: WritableSignal<{ action: MapToolbarAction; payload?: MapToolbarPayload } | null> = signal<{
    action: MapToolbarAction;
    payload?: MapToolbarPayload | undefined;
  } | null>(null);

  emitAction(action: MapToolbarAction, payload?: MapToolbarPayload) {
    this.actionSignal.set({ action, payload });
  }

  clearAction() {
    this.actionSignal.set(null);
  }
}
